import { render } from "./DocumentsIndex.vue?vue&type=template&id=5cae1d8c&scoped=true"
import script from "./DocumentsIndex.vue?vue&type=script&lang=js"
export * from "./DocumentsIndex.vue?vue&type=script&lang=js"

import "./DocumentsIndex.vue?vue&type=style&index=0&id=5cae1d8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cae1d8c"]])

export default __exports__